import { h } from '../index.js';
export const selectAuthToken = (state) => {
    const authToken = state.authToken;
    if (!h.isLoaded(authToken)) {
        return '';
    }
    return authToken.data;
};
//# sourceMappingURL=selectors.js.map